import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BatchRecogListItem extends SearchModelBase {
    actionDate: string = '';
    fromActionDate: string = '';
    toActionDate: string = '';
    actionUser: string = '';
    operation: string = '';
    periodFromDate: string = '';
    fromPeriodFromDate: string = '';
    ToPeriodFromDate: string = '';
    periodToDate: string = '';
    fromPeriodToDate: string = '';
    ToPeriodToDate: string = '';
    recogDate: string = '';
    fromRecogDate: string = '';
    ToRecogDate: string = '';
    recogCount: number = 0;
    fromRecogCount: number = 0;
    ToRecogCount : number = 0;
    estMargin: number = 0;
    FromEstMargin: number = 0;
    ToEstMargin: number = 0;
    

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Action Date', width: 150, dataIndex: 'actionDate',type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 1, text: 'User', width: 100, dataIndex: 'actionUser'}),
        //XCol.Create({ col: 2, text: 'Operation', width: 120, dataIndex: 'operation'}),
        XCol.Create({ col: 2, text: 'From Date', width: 80, dataIndex: 'periodFromDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 3, text: 'To Date', width: 80, dataIndex: 'periodToDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 4, text: 'Recog Date', width: 80, dataIndex: 'recogDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 5, text: 'Item Count', width: 70, dataIndex: 'recogCount', type: XCol.XCellType.Double, formatString: '#,##0'}),
        XCol.Create({ col: 6, text: 'Est. Margin', width: 100, dataIndex: 'estMargin', type: XCol.XCellType.Double, formatString: '#,##0.00'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: BatchRecogListItem.prototype.actionDate, orderByAscending: true };

    public static formatData(data: BatchRecogListItem[]) {
        return data.map((d: BatchRecogListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        actionDate: {from: 'fromActionDate', to: 'toActionDate'},
        periodFromDate: {from: 'fromPeriodFromDate', to: 'ToPeriodFromDate'},
        periodToDate: {from: 'fromPeriodToDate', to: 'ToPeriodToDate'},
        recogDate: {from: 'fromRecogDate', to: 'ToRecogDate'},
        recogCount: {from: 'fromRecogCount', to: 'ToRecogCount'},
        estMargin: {from: 'FromEstMargin', to: 'ToEstMargin'}
    }

}
